export const NAVIGATION_CHANNEL = 'navigation';

export const ANALYTICS_CONTEXT = {
	source: 'atlassianAccountMenu',
	componentName: 'atlassianAccountMenu',
	packageName: process.env._PACKAGE_NAME_,
	packageVersion: process.env._PACKAGE_VERSION_,
} as const;
